<template>
  <div class="container">
    <van-nav-bar
      title="充电记录"
      left-text=""
      left-arrow
      @click-left="onClickLeft"
      @click-right="onClickRight"
    >
      <template #right>
        <van-icon name="search" size="18" />
      </template>
    </van-nav-bar>

    <van-tabs
      @click="changeTab"
      color="#2FAAFF"
      title-inactive-color="#474542"
      title-active-color="#2FAAFF"
      v-model="tab_active"
      swipeable
    >
      <van-tab title="全部">
        <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="projectList.length > 0 ? '没有更多了' : '暂无数据'"
          @load="onLoad"
        >
          <div class="list-box">
            <div
              class="list clearfix"
              @click="changePage(item.id)"
              :key="index"
              v-for="(item, index) in projectList"
            >
              <div class="fl_left">
                <div>{{ item.createTime }}</div>
              </div>
              <div class="fl_right">
                <div class="innet_left">
                  <div class="mg10">{{ item.name }}</div>
                  <div class="mg10">{{ item.mobile }}</div>
                  <div class="mg10">{{ item.mainNo }}-{{ item.loopNo }}</div>
                </div>
                <div class="inner_right">
                  <div class="mg10">
                    <span class="col_b" v-if="item.status == 30">{{
                      item.statusDesc
                    }}</span>
                    <span class="col_c" v-else-if="item.status == 60">{{
                      item.statusDesc
                    }}</span>
                    <span v-else>{{ item.statusDesc }}</span>
                  </div>
                  <div class="mg10">
                    <span>{{ item.payAmount }}元</span>
                    <img src="../assets/img/sel_right.png" alt="" />
                  </div>
                  <div class="mg10" v-if="item.statusDesc!='充电中'">{{ getMinute(item.startTime, item.endTime) }}分钟</div>
                </div>
              </div>
            </div>
          </div>
        </van-list>
        <div class="noData" v-if="projectList.length == 0 && firstEnter">
          列表默认为空，请根据筛选条件查询
        </div>
      </van-tab>
      <van-tab title="充电中">
        <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="projectList.length > 0 ? '没有更多了' : '暂无数据'"
          @load="onLoad"
        >
          <div class="list-box">
            <div
              class="list clearfix"
              @click="changePage(item.id)"
              :key="index"
              v-for="(item, index) in projectList"
            >
              <div class="fl_left">
                <div>{{ item.createTime }}</div>
              </div>
              <div class="fl_right">
                <div class="innet_left">
                  <div class="mg10">{{ item.name }}</div>
                  <div class="mg10">{{ item.mobile }}</div>
                  <div class="mg10">{{ item.mainNo }}-{{ item.loopNo }}</div>
                </div>
                <div class="inner_right">
                  <div class="mg10">
                    <span class="col_b" v-if="item.status == 30">{{
                      item.statusDesc
                    }}</span>
                    <span class="col_c" v-else-if="item.status == 60">{{
                      item.statusDesc
                    }}</span>
                    <span v-else>{{ item.statusDesc }}</span>
                  </div>
                  <div class="mg10">
                    <span>{{ item.payAmount }}元</span>
                    <img src="../assets/img/sel_right.png" alt="" />
                  </div>
                  <div class="mg10"></div>
                </div>
              </div>
            </div>
          </div>
        </van-list>
        <div class="noData" v-if="projectList.length == 0 && firstEnter">
          列表默认为空，请根据筛选条件查询
        </div>
      </van-tab>
      <van-tab title="已退款">
        <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="projectList.length > 0 ? '没有更多了' : '暂无数据'"
          @load="onLoad"
        >
          <div class="list-box">
            <div
              class="list clearfix"
              @click="changePage(item.id)"
              :key="index"
              v-for="(item, index) in projectList"
            >
              <div class="fl_left">
                <div>{{ item.createTime }}</div>
              </div>
              <div class="fl_right">
                <div class="innet_left">
                  <div class="mg10">{{ item.name }}</div>
                  <div class="mg10">{{ item.mobile }}</div>
                  <div class="mg10">{{ item.mainNo }}-{{ item.loopNo }}</div>
                </div>
                <div class="inner_right">
                  <div class="mg10">
                    <span class="col_b" v-if="item.status == 30">{{
                      item.statusDesc
                    }}</span>
                    <span class="col_c" v-else-if="item.status == 60">{{
                      item.statusDesc
                    }}</span>
                    <span v-else>{{ item.statusDesc }}</span>
                  </div>
                  <div class="mg10">
                    <span>{{ item.payAmount }}元</span>
                    <img src="../assets/img/sel_right.png" alt="" />
                  </div>
                  <div class="mg10">{{ getMinute(item.startTime, item.endTime) }}分钟</div>
                </div>
              </div>
            </div>
          </div>
        </van-list>
        <div class="noData" v-if="projectList.length == 0 && firstEnter">
          列表默认为空，请根据筛选条件查询
        </div>
      </van-tab>
      <van-tab title="已完成">
        <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="projectList.length > 0 ? '没有更多了' : '暂无数据'"
          @load="onLoad"
        >
          <div class="list-box">
            <div
              class="list clearfix"
              @click="changePage(item.id)"
              :key="index"
              v-for="(item, index) in projectList"
            >
              <div class="fl_left">
                <div>{{ item.createTime }}</div>
              </div>
              <div class="fl_right">
                <div class="innet_left">
                  <div class="mg10">{{ item.name }}</div>
                  <div class="mg10">{{ item.mobile }}</div>
                  <div class="mg10">{{ item.mainNo }}-{{ item.loopNo }}</div>
                </div>
                <div class="inner_right">
                  <div class="mg10">
                    <span class="col_b" v-if="item.status == 30">{{
                      item.statusDesc
                    }}</span>
                    <span class="col_c" v-else-if="item.status == 60">{{
                      item.statusDesc
                    }}</span>
                    <span v-else>{{ item.statusDesc }}</span>
                  </div>
                  <div class="mg10">
                    <span>{{ item.payAmount }}元</span>
                    <img src="../assets/img/sel_right.png" alt="" />
                  </div>
                  <div class="mg10">{{ getMinute(item.startTime, item.endTime) }}分钟</div>
                </div>
              </div>
            </div>
          </div>
        </van-list>
        <div class="noData" v-if="projectList.length == 0 && firstEnter">
          列表默认为空，请根据筛选条件查询
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import axios from "@/axios.js";
import { NavBar, Icon, Image, Toast, Loading, Button, Tab, Tabs, List } from "vant";
export default {
  data() {
    return {
      keyword: "",
      allCount: 0,
      pageIndex: 1,
      pageSize: 10,
      loading: false,
      finished: false,
      projectList: [],
      tab_active: 0,
      activeNames: [],
      orderStatus: "", //状态
      firstEnter: true,
    };
  },
  components: {
    [NavBar.name]: NavBar,
    [Icon.name]: Icon,
    [Image.name]: Image,
    [Toast.name]: Toast,
    [Loading.name]: Loading,
    [Button.name]: Button,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [List.name]: List,
  },
  methods: {
    changePage(id) {
      this.$router.push({ path: "chargeDetail.html", query: { orderId: id } });
    },
    changeTab() {
      this.pageIndex = 1;
      this.finished = false;
      this.projectList = [];
      if (this.tab_active == 0) {
        this.orderStatus = "";
      } else if (this.tab_active == 1) {
        this.orderStatus = 30;
      } else if (this.tab_active == 2) {
        this.orderStatus = 60;
      } else {
        this.orderStatus = 70;
      }
      this.getProjectList();
    },
    onLoad() {
      // 异步更新数据
      if (this.firstEnter) {
        this.loading = false;
      } else {
        setTimeout(() => {
          this.pageIndex++;
          this.getMoreList();
        }, 500);
      }
    },
    getProjectList() {
      this.firstEnter = false;
      this.loading = true;
      axios
        .post("/charge/pagelist", {
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          filter: {
            keyword: this.keyword,
            mainNo: this.mainNo,
            startTime: this.startTime,
            endTime: this.endTime,
            chargeOrderStatus: this.orderStatus,
          },
        })
        .then((res) => {
          // 加载状态结束
          this.loading = false;
          this.projectList = res.data.list;
          this.allCount = res.data.total;
          this.statistics = res.data.statistics;
        });
    },
    getMoreList() {
      axios
        .post("/charge/pagelist", {
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          filter: {
            keyword: this.keyword,
            startTime: this.startTime,
            endTime: this.endTime,
            chargeOrderStatus: this.orderStatus,
          },
        })
        .then((res) => {
          this.projectList = this.projectList.concat(res.data.list);
          this.allCount = res.data.total;
          // 加载状态结束
          this.loading = false;
          // 数据全部加载完成
          if (this.pageIndex * this.pageSize >= this.allCount) {
            this.finished = true;
          }
        });
    },
    onClickLeft() {
      sessionStorage.setItem("chargeDetailBack", false);
      if (this.$route.query.back) {
        this.$router.back();
      } else {
        this.$router.replace({ path: "home.html" });
      }
    },
    onClickRight() {
      this.$router.push({ path: "search.html", query: { pageType: 3 } });
    },
    getMinute(startTime, endTime) {
      let diff = new Date(endTime) - new Date(startTime);
      return (diff / 1000 / 60).toFixed(0);
    },
  },
  computed: {},
  created() {
    this.firstEnter = sessionStorage.getItem("chargeDetailBack") == "true" ? false : true;
    this.keyword = this.$route.query.keyword;
    this.mainNo = this.$route.query.mainNo;
    this.startTime = this.$route.query.startTime;
    this.endTime = this.$route.query.endTime;
    if (
      this.keyword ||
      this.mainNo ||
      this.startTime ||
      this.endTime ||
      !this.firstEnter
    ) {
      this.getProjectList();
    }
  },
  destroyed() {},
};
</script>
<style lang="less" scoped>
body,
html {
  width: 100%;
  height: 100%;
  background: #f0f4f7;
}
.container {
  width: 100%;
  height: 100%;
  letter-spacing: 0px;
  background: #f0f4f7;
}
.list-box {
  width: 100%;
  color: #373737;
  .list {
    font-size: 14px;
    width: 100%;
    background: #fff;
    margin: 12px 0;
    padding: 12px;
    display: flex;
    height: 100px;
    .fl_left {
      display: flex;
      align-items: center;
      height: 100%;
      vertical-align: middle;
      width: 80px;
      margin-right: 10px;
    }
    .fl_right {
      flex: 1;
      display: flex;
      align-items: center;
      margin-top: 10px;
      .innet_left {
        flex: 1;
      }
      .inner_right {
      }
      img {
        width: 6px;
        height: 10px;
        margin-left: 30px;
        vertical-align: middle;
      }
    }
  }
  .mg10 {
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .bold {
    font-weight: bold;
  }
}

/deep/.van-cell {
  padding: 0;
}
/deep/.van-cell__right-icon {
  color: #5ba7fc;
}
</style>
